import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const SelfServe = lazyWithRetry(() => import('./SelfServe'));
type Props = RouteComponentProps;

const SelfServeRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="subscriptions-self-serve">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <SelfServe />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default SelfServeRoutes;
